import { useEffect, useState } from 'react';
import { Box, Stack } from '@mui/material';
import SettingsSection from './settingsSection';

type Props = {
  entity: any;
  maxHeight?: number;
  errors: any;
  onSettingChange: (settingName: string, value: any) => void;
};

const EntitySettings = ({ entity, errors, maxHeight, onSettingChange }: Props) => {
  const [settingDefs, setSettingDefs] = useState<any[]>([]);

  useEffect(() => {
    const entitDef = entity.dataSourceDef || entity.agentDef || entity.userAppDef;
    setSettingDefs(entitDef.settingDefs);
  }, [entity]);

  return (
    <Box sx={{ height: maxHeight ? `${maxHeight}px` : '100%', display: 'flex', flexDirection: 'column' }}>
      <Stack spacing={1} sx={{ flexGrow: 1, overflow: 'hidden' }}>
        <Box sx={{ overflowY: 'auto', flexGrow: 1, p: 1 }}>
          {settingDefs
            .filter((section: any) => !section.system)
            .map((section: any) => (
              <SettingsSection
                key={section.sectionName}
                entityDefId={entity.entityDefId}
                settings={entity.settings}
                settingsSection={section}
                errors={errors}
                onChange={onSettingChange}
              />
            ))}
        </Box>
      </Stack>
    </Box>
  );
};

export default EntitySettings;
